/* global document */
'use strict';

import {getHTML} from '../xhr';
import {escapeSelector} from '../utils';
import log from '../logger';
import event from '../event';
import docReady from '../documentReady';

export default function load(files, cb) {
    if (files.length === 0) {
        cb();
        return;
    }

    let downloadCount = 0;
    let error;

    files.forEach((file) => {
        if (file.html) {
            loadHTML(null, file);
        } else if (file.url) {
            getHTML(file.url, (err, html) => {
                file.html = html;
                loadHTML(err, file);
            });
        }
    });

    function loadHTML(err, file) {
        if (err) {
            event.trigger('error.file.html', {error: err, file});
            doCallback(err);
            return;
        }

        doLoadHTML(file, true);
    }

    function doLoadHTML(file, waitForDocReady) {
        const selector = `[v-few-frg-loader=${escapeSelector(file.zone)}]`;
        const elem = document.querySelector(selector);

        // hide HTML until css/js are loaded, but add it to the DOM so that js can manipulate DOM.
        if (elem) {
            // delay load until html element is found.
            event.trigger('load.file.html', {file});

            file.elem = elem.cloneNode();
            file.elem.innerHTML = file.html;
            file.elem.style.display = 'none';
            elem.insertAdjacentElement('afterend', file.elem);
        } else {
            log.debug(`htmlLoader(): could not find element ${selector}`);

            if (waitForDocReady) {
                log.debug(`htmlLoader(): wait for doc ready and retry element ${selector}`);

                // need to wait for docReady if HTML file is cached. selector element could not be in the DOM yet.
                docReady(() => doLoadHTML(file, false));
                return;
            }
        }

        doCallback();
    }

    function doCallback(err) {
        downloadCount++;
        error = err || error;

        if (downloadCount === files.length) {
            cb(error);
        }
    }
}
